import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { ThemedButton } from '@awarego-ui/components';

const ThemedFooterLinkButton = styled(ThemedButton)`
    ${(props) =>
        props.continue &&
        css`
            margin-left: auto;
        `};
    ${(props) =>
        props.footer &&
        css`
            margin-right: 20px;
        `};
`;

const ThemedLinkButton = (props) => {
    const navigate = useNavigate();
    const {
        to,
        onClick,
        // ⬆ filtering out props that `button` doesn't know what to do with.
        ...rest
    } = props;
    return (
        <ThemedFooterLinkButton
            {...rest} // `children` is just another prop!
            onClick={(event) => {
                onClick && onClick(event);
                navigate(to);
            }}
        />
    );
};

export default ThemedLinkButton;
